import(/* webpackMode: "eager" */ "/app/apps/topshop/app/global-error.tsx");
